import { animate, AnimationBuilder, style } from '@angular/animations';
import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

import { filter, take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class FuseSplashScreenService {
  private splashScreenElement = this.document.body.querySelector('#fuse-splash-screen') as HTMLDivElement;
  private bodyElement = this.document.querySelector('body') as HTMLBodyElement;

  constructor(
    @Inject(DOCUMENT) private readonly document: Document,
    private readonly animationBuilder: AnimationBuilder,
    private readonly router: Router
  ) {
    this.init();
  }

  private init(): void {
    this.router.events
      .pipe(filter(((event) => event instanceof NavigationEnd)), take(1))
      .subscribe(() => setTimeout(() => {
        this.hide();
      }, 0));
  }

  show(): void {
    this.bodyElement.prepend(this.splashScreenElement, this.bodyElement.firstChild);

    const shotAnimation = this.animationBuilder
      .build([
        style({ opacity: '0', zIndex: '99999' }),
        animate('300ms ease', style({ opacity: '1' }))
      ])
      .create(this.splashScreenElement);


    setTimeout(() => {
      shotAnimation.play();
    }, 0);

  }

  hide(): void {
    this.splashScreenElement.remove();
  }
}
